import MojitoPresentation from 'mojito/presentation';
import SelectionButton from 'modules/selection-button/index.js';

const { FlexPane, Image, Text } = MojitoPresentation.Components;

const PriceBoostBanner = props => {
    const { mojitoTools, event, market, basePrice, selection, bettingContext } = props;
    const { config, stringResolver } = mojitoTools;

    return (
        <FlexPane class="ta-PriceBoostBanner" config={config.priceBoostContainer}>
            <FlexPane config={config.priceBoostTitleAndImageContainer}>
                <FlexPane config={config.priceBoostImageContainer}>
                    <Image config={config.priceBoostImage} alt="Price boost image" />
                </FlexPane>
                <Text config={config.priceBoostTitle}>
                    {stringResolver.resolveString('$PRICE_BOOST_BANNER.PRICE_BOOST_TITLE')}
                </Text>
            </FlexPane>
            <FlexPane config={config.basePriceContainer}>
                <FlexPane config={config.basePriceInfoContainer}>
                    <Text config={config.basePriceTitle}>
                        {stringResolver.resolveString('$PRICE_BOOST_BANNER.BASE_PRICE_TITLE')}
                    </Text>
                    <Text config={config.basePriceAmount} class="ta-basePrice">
                        {basePrice}
                    </Text>
                </FlexPane>
                <Image config={config.basePriceImage} alt="Base price image" />
            </FlexPane>
            <SelectionButton
                config={config.selectionButton}
                selection={selection}
                event={event}
                marketStatus={market.status}
                marketType={market.type}
                marketId={market.id}
                bettingContext={bettingContext}
            />
        </FlexPane>
    );
};

export default PriceBoostBanner;
